// GENERATE BY ../scripts/generate.js
// DON NOT EDIT IT MANUALLY
/* eslint-disable */
import React, { forwardRef, MutableRefObject } from 'react';
import { IconProps } from '../type';
import classNames from 'classnames';
import useConfig from '../../_util/useConfig';
import useSizeProps from '../useSizeProps';

const CloseCircleFilledIcon = (props: IconProps, ref: MutableRefObject<SVGSVGElement>) => {
  const { classPrefix } = useConfig();
  const { size, className: customClassName, style: customStyle, ...restProps } = props;
  const { className: sizeClassName, style: sizeStyle } = useSizeProps(size);
  const className = classNames(classPrefix + '-icon',classPrefix+'-icon-close-circle-filled', sizeClassName, customClassName);
  const style = { ...customStyle, ...sizeStyle }

  return (
    <svg ref={ref} className={className} style={style} {...restProps} viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path fillOpacity=".9" fillRule="evenodd" d="M512 96C741.7504576 96 928 282.24954432 928 512 928 741.7504576 741.7504576 928 512 928 282.24954432 928 96 741.7504576 96 512 96 282.24954432 282.24954432 96 512 96ZM647.7644992 330.98066432L511.97266432 466.72466432 376.23549824 330.98066432 330.98066432 376.23549824 466.72466432 511.97266432 330.98066432 647.7644992 376.23549824 693.0193344 511.97266432 557.22066432 647.7644992 693.0193344 693.0193344 647.7644992 557.22066432 511.97266432 693.0193344 376.23549824 647.7644992 330.98066432Z"/></svg>
  )
};

CloseCircleFilledIcon.displayName = 'CloseCircleFilledIcon';

export default forwardRef<SVGSVGElement, IconProps>(CloseCircleFilledIcon);
